

import { ClearAnswer } from '../ClearAnswer';
import { InterceptMiddle } from '../../regular';
/**
 * 跳转函数
 * @param code 被跳转试题的编码
 * @param conditionArr  完整的条件list
 * @param list 试题list
 * @param state 1 跳转，0 复原
 * @return Boolean
 */
export const JumpTo = (code, conditionArr, list, state) => {
    
    // console.warn('3 :>> ', 3);
    let index = -1,
    jumpToIndex = list.findIndex(ques => ques.quesCode == code),
    codeList = []
    conditionArr.forEach( info => {
        // console.log('info :>> ', info);
        let code = InterceptMiddle(info, ['Exist[', '!Exist[', 'Include[', '[', 'IsShow[', '!IsShow[', 'IsAnswered['], ['==', '>','>=', '<', '<=', '_', ':', ']'])
        // console.log('code :>> ', code);
        codeList = code.split(',')
        codeList.forEach(codeItem => {
            list.forEach((ques, quesIndex) => {
                if (ques.quesCode == codeItem) {
                }
                if (ques.quesCode == codeItem && 
                    quesIndex > index &&
                    ques.isShow &&
                    ques.bindIsShow
                    ) {
                        index = quesIndex
                    }
            });
        })
    })
    list.forEach((ques, quesIndex) => {
        if (index != -1 && quesIndex > index && quesIndex < jumpToIndex) {
            if(state == 1) {
                ques.isShow = false
                ques = ClearAnswer(ques)
            } else {
                ques.isShow = true
            }
        }
    });
}

